angular.module('NiacsProjectApp.controllers-step2', [
])
.controller('AddEditCisCtrl',['$scope','$uibModalInstance','unit','theStatement',
    function($scope,$uibModalInstance,unit,theStatement){
        $scope.dismiss = $uibModalInstance.dismiss;
        $scope.unit = unit;
        $scope.theStatement = theStatement;
        $scope.newLink = null;
        $scope.save = function() {
            niacs.info("save.theStatement",$scope.theStatement);
            $uibModalInstance.close($scope.theStatement);
        };
        $scope.addLink = function() {
            if(!$scope.theStatement.external_link) {
                $scope.theStatement.external_link = [];
            }
            $scope.theStatement.external_link.push({});
        };
        $scope.removeLink = function(link) {
            if(link && $scope.theStatement.external_link) {
                for(var i = 0; i < $scope.theStatement.external_link.length; i++) {
                    if(link.url === $scope.theStatement.external_link[i].url &&
                       link.title === $scope.theStatement.external_link[i].title) {
                        return $scope.theStatement.external_link.splice(i,1);
                    }
                }
            }
        };
}])
.controller('ImpactsCtrl',['$scope','$routeParams','$filter','ProjectService','AutoSaveService','DialogService',
    function($scope,$routeParams,$filter,ProjectService,AutoSaveService,DialogService) {
        // add/remove of pre-defined units to/from a unit (project wide unit==null)
        $scope.addCiStatement = function(statement,holder) {
            niacs.info("addCiStatement.statement",statement);
            niacs.info("addCiStatement.holder",holder);
            AutoSaveService.startSaving();
            if(statement.id) { // pre-defined
                statement = {id: statement.id};
            } else { // user-defined
                statement.id = niacs.guid();
            }
            if(!holder.cistatements) {
                holder.cistatements = [];
            }
            holder.cistatements.push(statement);
            ProjectService.save();
        };
        $scope.removeCiStatement = function(statement,holder) {
            niacs.info("removeCiStatement.statement",statement);
            niacs.info("removeCiStatement.holder",holder);
            function doRemove() {
                if(!niacs.removeById(holder.cistatements,statement.id)) {
                    niacs.info("unable to find cistatement to remove",statement);
                }
                AutoSaveService.startSaving();
                ProjectService.save();
            }
            var hasComments = (statement.comments||statement.statement),
                isCustom = angular.isString(statement.id);
            if(holder.vulnerability || hasComments || isCustom) {
                var dialogContents = {
                  message: 'Are you sure you want to remove this climate impact statement?',
                  okText: 'Yes, remove it',
                  cancelText: 'No, keep it',
                  conditions: []
                };
                if(isCustom || hasComments) {
                    dialogContents.warning = "This cannot be undone.";
                }
                if(hasComments) {
                    dialogContents.conditions.push('You have entered comments about this climate impact.');
                } else if (!isCustom) {
                    dialogContents.type = '?';
                }
                if(holder.vulnerability) {
                    dialogContents.more = 'You have already determined the vulnerability of this management topic. If you remove this climate impact statement, you may need to reconsider your vulnerability determination.';
                    /*'You are removing a climate impact statement from '+(holder.label||holder.$label)+' which you have '+
                        'already determined the vulnerability of.  Are you sure you want to do this?  If so you may need to consider '+
                        'revisiting your vulnerability determination.';*/
                }
                if(isCustom && statement.external_link && statement.external_link.length) {
                    dialogContents.conditions.push("You have specified evidence for this climate impact.");
                }
                DialogService.safe(dialogContents).then(function() {
                  niacs.info('user confirmed removal of cis with already determined vulnerability.');
                  doRemove();
                });
            } else {
                doRemove();
            }

        };
        $scope.saveCiStatement = function(statement) {
            niacs.info("saveCiStatement.statement",statement);
            ProjectService.save();
        };
        function getContexts() {
            var project = $scope.project,contexts,i;
            if(project && project.$vuln_region && project.$vuln_region.$units) {
                //unit in project.units | inflate:project.$vuln_region.$units
                contexts = [project].concat($filter('inflate')(project.units,project.$vuln_region.$units)).filter(function(c){
                    return c !== undefined;
                });
                if($scope.contexts && $scope.contexts.length) {
                    for(i = 0; i < contexts.length; i++) {
                        angular.extend($scope.contexts[i], contexts[i]);
                    }
                } else {
                    $scope.contexts = contexts;
                }
                angular.forEach($scope.contexts,function(unit) {
                    // this is perhaps a workaround to a problem that is not entirely well understood but
                    // if the array doesn't exist initially then on step 2.1 if you add a cis to a unit (with undefined cis array)
                    // and then switch to another unit (with undefined cis array) and add one there, the second modification will NOT
                    // stick.  this must almost certainly have to do with the UI having an array reference
                    // that isn't IN the model yet so it creates a new one that no longer remains bound to
                    // the project so while it appears the newly added cis stick they disappear when moving away and returning.
                    if(!unit.cistatements) {
                        unit.cistatements = [];
                    }
                });
            }
        }
        $scope.$watch('project.$vuln_region.$units',getContexts);
        $scope.$watch('project.$updateCount',getContexts);
        ProjectService.get($routeParams,'ImpactsCtrl',function(p){
            $scope.project = p;
        });
}])
.controller('VulnerabilityCtrl',['$scope','$routeParams','$filter','ProjectService','AutoSaveService','$uibModal','NiacsStrategyService',
    function($scope,$routeParams,$filter,ProjectService,AutoSaveService,$uibModal,NiacsStrategyService){
    function getContexts() {
        var project = $scope.project,contexts,i;
        if(project && project.$vuln_region && project.$vuln_region.$units) {
            NiacsStrategyService.projectIsOnlyAgriculture().then(function(isAgriculture){
                $scope.isAgriculture = isAgriculture;
                //unit in project.units | inflate:project.$vuln_region.$units
                contexts = $filter('inflate')(project.units,project.$vuln_region.$units);
                if($scope.vocab_vulnerability) {
                    angular.forEach(contexts,function(context){
                        if(angular.isNumber(context.$adaptive_capacity) && angular.isNumber(context.$potential_impacts)) {
                            var vidx = niacs.vulnerabilityIndex(context.$adaptive_capacity,context.$potential_impacts);
                            // over-ride $unit_vulnerability if set with calculated vulnerability
                            context.$unit_vulnerability = $scope.vocab_vulnerability[vidx].label;
                        }
                    });
                }
                if($scope.contexts) {
                    for(i = 0; i < contexts.length; i++) {
                        $scope.contexts[i] = contexts[i];
                    }
                } else {
                    $scope.contexts = contexts;
                }
            });
        }
    }
    $scope.$watch('project.$vuln_region.$units',getContexts);
    $scope.$watch('project.$updateCount',getContexts);
    ProjectService.get($routeParams,'VulnerabilityCtrl',function(p){
        $scope.project = p;
    });
}]);
